/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AbstractAttributeValue": [
      "BooleanAttributeValue",
      "FloatAttributeValue",
      "FullDateStrAttributeValue",
      "IntegerAttributeValue",
      "PercentageRateAttributeValue",
      "StringArrayAttributeValue",
      "StringAttributeValue"
    ],
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "AttributeValue": [
      "StringAttributeValue",
      "FloatAttributeValue",
      "IntegerAttributeValue",
      "BooleanAttributeValue",
      "PercentageRateAttributeValue",
      "FullDateStrAttributeValue",
      "StringArrayAttributeValue"
    ],
    "AttributeValueFloatDisplay": [
      "AttributeValueCurrencyDisplay"
    ],
    "BaseThreadV2": [
      "DeliverableThread",
      "FundingRequestThread",
      "InvoiceThread",
      "LimitedPartnerThread",
      "ValleyBankLoanAccountThread"
    ],
    "CategorySpecificProperties": [
      "FundingRequestTaskSpecificProperties",
      "InvoiceTaskSpecificProperties",
      "ConsolidatedDisbursementTaskProperties",
      "LenderSharesTaskSpecificProperties"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "FinancialCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig",
      "FinancialStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "EventLog": [
      "ThreadCreatedEvent",
      "DeliverableThreadCreateEvent",
      "FundingRequestCreatedEvent",
      "FundingRequestStatusChangeEvent",
      "FundingRequestThreadCreateEvent",
      "LimitedPartnerCreatedEvent",
      "LimitedPartnerMappingMatchEvent",
      "LimitedPartnerMappingUnmatchEvent",
      "LimitedPartnerThreadCreateEvent",
      "LimitedPartnerUpdatedEvent",
      "ValleyBankLoanAccountThreadCreateEvent",
      "InvoiceCreatedEvent",
      "InvoiceThreadCreateEvent",
      "InvoiceUpdatedEvent"
    ],
    "EventLogBaseEvent": [
      "DeliverableThreadCreateEvent",
      "FundingRequestCreatedEvent",
      "FundingRequestStatusChangeEvent",
      "FundingRequestThreadCreateEvent",
      "InvoiceCreatedEvent",
      "InvoiceThreadCreateEvent",
      "InvoiceUpdatedEvent",
      "LimitedPartnerCreatedEvent",
      "LimitedPartnerMappingMatchEvent",
      "LimitedPartnerMappingUnmatchEvent",
      "LimitedPartnerThreadCreateEvent",
      "LimitedPartnerUpdatedEvent",
      "ThreadCreatedEvent",
      "ValleyBankLoanAccountThreadCreateEvent"
    ],
    "FundingMechanicsConstraint": [
      "FundingMechanicsNonConditionConstraint",
      "FundingMechanicsConditionConstraint"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ],
    "SuccessOrErrorPortfolioCovenant": [
      "SuccessPortfolioCovenant",
      "ErrorPortfolioCovenant"
    ],
    "ThreadV2": [
      "DeliverableThread",
      "FundingRequestThread",
      "LimitedPartnerThread",
      "ValleyBankLoanAccountThread",
      "InvoiceThread"
    ],
    "ValidateAndCreateWorkflowTemplateResponse": [
      "ErrorCreateWorkflowTemplateResponse",
      "SuccessCreateWorkflowTemplateResponse"
    ],
    "WorkflowActionStaticParamTemplateType": [
      "StringStaticParamTemplate",
      "NumberStaticParamTemplate",
      "StringArrayStaticParamTemplate"
    ],
    "WorkflowRuntimeVariableTemplate": [
      "StringRuntimeVariableTemplate",
      "StringArrayRuntimeVariableTemplate",
      "NumberRuntimeVariableTemplate"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AbstractAttributeValue": [
      "BooleanAttributeValue",
      "FloatAttributeValue",
      "FullDateStrAttributeValue",
      "IntegerAttributeValue",
      "PercentageRateAttributeValue",
      "StringArrayAttributeValue",
      "StringAttributeValue"
    ],
    "Actor": [
      "ApiKeyWithOrganization",
      "FinleyAutomated",
      "UnknownActor",
      "UserActor"
    ],
    "AttributeValue": [
      "StringAttributeValue",
      "FloatAttributeValue",
      "IntegerAttributeValue",
      "BooleanAttributeValue",
      "PercentageRateAttributeValue",
      "FullDateStrAttributeValue",
      "StringArrayAttributeValue"
    ],
    "AttributeValueFloatDisplay": [
      "AttributeValueCurrencyDisplay"
    ],
    "BaseThreadV2": [
      "DeliverableThread",
      "FundingRequestThread",
      "InvoiceThread",
      "LimitedPartnerThread",
      "ValleyBankLoanAccountThread"
    ],
    "CategorySpecificProperties": [
      "FundingRequestTaskSpecificProperties",
      "InvoiceTaskSpecificProperties",
      "ConsolidatedDisbursementTaskProperties",
      "LenderSharesTaskSpecificProperties"
    ],
    "DeliverableArtifactConfig": [
      "CashBalancesFeedConfig",
      "SupplementalTapeConfig",
      "LoanTapeConfig",
      "RepaymentTapeConfig",
      "PortfolioCovenantConfig",
      "FinancialCovenantConfig",
      "OrgProvidedInputConfig",
      "MonthlyServicerReportConfig",
      "MonthlyStatementConfig",
      "FinancialStatementConfig"
    ],
    "DeliverableArtifactInstanceDownload": [
      "ArtifactInstanceDownloadUrl",
      "ArtifactInstanceDownloadObject"
    ],
    "EventLog": [
      "ThreadCreatedEvent",
      "DeliverableThreadCreateEvent",
      "FundingRequestCreatedEvent",
      "FundingRequestStatusChangeEvent",
      "FundingRequestThreadCreateEvent",
      "LimitedPartnerCreatedEvent",
      "LimitedPartnerMappingMatchEvent",
      "LimitedPartnerMappingUnmatchEvent",
      "LimitedPartnerThreadCreateEvent",
      "LimitedPartnerUpdatedEvent",
      "ValleyBankLoanAccountThreadCreateEvent",
      "InvoiceCreatedEvent",
      "InvoiceThreadCreateEvent",
      "InvoiceUpdatedEvent"
    ],
    "EventLogBaseEvent": [
      "DeliverableThreadCreateEvent",
      "FundingRequestCreatedEvent",
      "FundingRequestStatusChangeEvent",
      "FundingRequestThreadCreateEvent",
      "InvoiceCreatedEvent",
      "InvoiceThreadCreateEvent",
      "InvoiceUpdatedEvent",
      "LimitedPartnerCreatedEvent",
      "LimitedPartnerMappingMatchEvent",
      "LimitedPartnerMappingUnmatchEvent",
      "LimitedPartnerThreadCreateEvent",
      "LimitedPartnerUpdatedEvent",
      "ThreadCreatedEvent",
      "ValleyBankLoanAccountThreadCreateEvent"
    ],
    "FundingMechanicsConstraint": [
      "FundingMechanicsNonConditionConstraint",
      "FundingMechanicsConditionConstraint"
    ],
    "Payload": [
      "FundingRequestPayload",
      "FundingRequestComponentPayload",
      "DeliverablesPayload",
      "IngestionPayload",
      "InsertedDeliverablePayload",
      "UpdatedDeliverableStatusPayload",
      "SubmittedDeliverableSubmissionPayload",
      "VerificationPayload"
    ],
    "PostgresQueryInputValues": [
      "PrincipalBalanceDailyAverageInputValues",
      "TAccountsSumInputValues",
      "OrgProvidedInputInputValues"
    ],
    "ReportTemplate": [
      "BaseReportTemplate"
    ],
    "SuccessOrErrorPortfolioCovenant": [
      "SuccessPortfolioCovenant",
      "ErrorPortfolioCovenant"
    ],
    "ThreadV2": [
      "DeliverableThread",
      "FundingRequestThread",
      "LimitedPartnerThread",
      "ValleyBankLoanAccountThread",
      "InvoiceThread"
    ],
    "ValidateAndCreateWorkflowTemplateResponse": [
      "ErrorCreateWorkflowTemplateResponse",
      "SuccessCreateWorkflowTemplateResponse"
    ],
    "WorkflowActionStaticParamTemplateType": [
      "StringStaticParamTemplate",
      "NumberStaticParamTemplate",
      "StringArrayStaticParamTemplate"
    ],
    "WorkflowRuntimeVariableTemplate": [
      "StringRuntimeVariableTemplate",
      "StringArrayRuntimeVariableTemplate",
      "NumberRuntimeVariableTemplate"
    ]
  }
};
      export default result;
    